import { Modal } from "antd";

export const showConfirmModal = ({
  onOk,
  onCancel,
  title,
  content,
  cancelText = "Remove",
  okText = "Retain",
  width = "38rem",
  centered = true,
}:{
  onOk?: () => void,
  onCancel?: () => void,
  title: string,
  content?: string,
  cancelText?: string,
  okText?: string,
  width?: string,
  centered?: boolean,
}) => {
  return Modal.confirm({
    title: title,
    content: content,
    okText: okText,
    cancelText: cancelText,
    centered,
    onOk,
    onCancel,
    width,
  })
};